import logo from "./logo.svg";
import "./App.css";
import "../src/Css/Style.css";
import "../src/Css/Responsive.css";
import "../src/style.css";
import "../src/Css/new-design.css";
import RoutesList from "./RoutesList";
import 'react-datepicker/dist/react-datepicker.css';



function App() {
  return (
    <div className="App">
      <RoutesList />
    </div>
  );
}

export default App;
